import {
  isExistingSubmission,
  isLoggedIn,
  isNewSubmission,
} from '../../utils/helpers';
import informationOnFile from './informationOnFile';
import roleNew from './roleNew';
import roleUpdate from './roleUpdate';
import submissionType from './submissionType';

export const applicationStatusPages = {
  submissionType: {
    path: 'submission-type',
    title: 'CHAMPVA application or enrollment status',
    depends: isLoggedIn,
    ...submissionType,
  },
  informationOnFile: {
    path: 'information-on-file',
    title: 'Information on file',
    depends: isExistingSubmission,
    ...informationOnFile,
  },
  certifierRoleNew: {
    path: 'your-role-in-this-submission',
    title: 'Your role in this application',
    depends: isNewSubmission,
    ...roleNew,
  },
  certifierRoleUpdate: {
    path: 'your-role-in-this-update',
    title: 'Your role in this update',
    depends: isExistingSubmission,
    ...roleUpdate,
  },
};
